import { MORE_RUN } from "./more/run";
import { MORE_OPERATIONS } from "./more/operations";
import { MORE_GROW } from "./more/grow";
import { MORE_BRAND } from "./more/brand";

// Extra sections per feature slug, written from help center articles.
// Shape: { tabLinks: { [tabValue]: href }, sections: [row | group] }
//   row:   { type: "row", title, description, image, href, linkLabel }
//   group: { type: "group", heading, intro?, cards: [{ title, description, image, href, linkLabel }] }
// `image` is a help-center path like "calendar/calendar-week-view".
const FEATURE_SHOWCASE_MORE = {
    ...MORE_RUN,
    ...MORE_OPERATIONS,
    ...MORE_GROW,
    ...MORE_BRAND,
};

export function getFeatureShowcaseMore(slug) {
    return FEATURE_SHOWCASE_MORE[slug] || null;
}
